@if (businessId && isMobile) {
  @if (isAvailableIntroduction && introduceHref) {
    <h2 class="share-header text-center color-black">
      Simply tap INTRODUCE then add the recipient’s name, phone number, or
      email.
    </h2>
  }
}
<div
  class="flex flex-wrap p-fluid justify-content-center align-items-center mi-share px-4 pb-4 bg-primary-linear">
  <div
    [ngClass]="{ 'flex-column-reverse': isAvailableIntroduction }"
    class="flex flex-wrap justify-content-center align-items-center">
    <a
      *ngIf="isAvailableIntroduction && introduceHref"
      [href]="introduceHref"
      (click)="trackIntroduceClick()"
      class="w-9 button-simple basic button-introduce mt-3 text-center"
      style="text-transform: none">
      <span class="text">INTRODUCE</span>
      (via 3 way
      {{
        introTextOptions?.preferredIntroMethod
          ? introduceTypeEnum[introTextOptions.preferredIntroMethod]
          : introduceTypeEnum[0]
      }})
    </a>
    <button
      (click)="introduce()"
      *ngIf="isAvailableIntroduction && !introduceHref"
      class="w-9 button-simple basic button-introduce mt-3 text-center"
      style="text-transform: none">
      <span class="text">INTRODUCE</span> <br />
      (via 3 way
      {{
        introTextOptions?.preferredIntroMethod
          ? introduceTypeEnum[introTextOptions.preferredIntroMethod]
          : introduceTypeEnum[0]
      }})
    </button>
    <div
      *ngIf="!isMobile && shareUrl"
      [ngClass]="{ 'mb-3': isAvailableIntroduction }"
      class="qr-code-container text-center">
      <app-angularx-qrcode
        *ngIf="shareUrl"
        #qrcode
        (click)="saveQrCode($event)"
        [level]="'M'"
        [qrdata]="shareUrl"
        [size]="150">
      </app-angularx-qrcode>
      <a (click)="saveQrCode(qrcode)" class="new-link pointer">Download</a>
    </div>
  </div>

  <div
    [ngClass]="{
      'mt-15': !isMobile,
      'mt-0': isAvailableIntroduction
    }"
    class="col-12 mi-share-copy">
    @if(isMobile)
    {
      <div class="flex justify-content-center align-items-center mb-2 mt-2">
        <p-toggleswitch
          (onChange)="shareTypeChange($event)"
          *ngIf="!is3WaySharingDisabled"
          [(ngModel)]="is3WaySharing"
          class="padding-sides-5 switch-color"
          style="transform: scale(0.8)"></p-toggleswitch>
        Include {{ introTextOptions.name }} in message
      </div>
    }
    <div
      [ngClass]="{ 'mb-3 p-0': isAvailableIntroduction }"
      class="col-12 mi-share-social mt-0"
      style="
        display: flex;
        justify-content: center;
        margin-top: 15px;
        height: auto;
      ">
      <div
        (click)="showQR(true)"
        *ngIf="isMobile"
        class="messenger"
        style="
          display: inline-flex;
          align-items: flex-start;
          position: relative;
          flex-direction: column;
        ">
        <img
          alt=""
          class="sms-button"
          src="assets/images/quick-share.png"
          style="height: 45px; border-radius: 10px; top: 0" />
        <div class="share-business__social-label">QR</div>
      </div>
      <div
        (click)="this.showSms(true)"
        class="messenger share-business__social-item">
        <svg
          id="svg8"
          class="sms-button share-business__social-image share-business__message-icon"
          height="66.145836mm"
          inkscape:version="0.92.2 (5c3e80d, 2017-08-06)"
          sodipodi:docname="iMessage logo.svg"
          version="1.1"
          viewBox="0 0 66.145836 66.145836"
          width="66.145836mm"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
          xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs id="defs2">
            <linearGradient id="linearGradient899" inkscape:collect="always">
              <stop
                id="stop895"
                class="share-business__message-gradient-start"
                offset="0" />
              <stop
                id="stop897"
                class="share-business__message-gradient-end"
                offset="1" />
            </linearGradient>
            <linearGradient
              id="linearGradient901"
              gradientTransform="matrix(0.98209275,0,0,0.98209275,-1.0651782,3.7961838)"
              gradientUnits="userSpaceOnUse"
              inkscape:collect="always"
              x1="-25.272568"
              x2="-25.272568"
              xlink:href="#linearGradient899"
              y1="207.52057"
              y2="152.9982" />
            <linearGradient
              id="linearGradient902"
              x1="0%"
              y1="0%"
              x2="0%"
              y2="100%">
              <stop class="share-business__intro-gradient-start" offset="0%" />
              <stop class="share-business__intro-gradient-end" offset="100%" />
            </linearGradient>
          </defs>
          <g
            id="layer1"
            inkscape:groupmode="layer"
            inkscape:label="Capa 1"
            transform="translate(59.483067,-145.8456)">
            <g id="g963">
              <rect
                id="rect826"
                [attr.fill]="
                  is3WaySharing
                    ? 'url(#linearGradient902)'
                    : 'url(#linearGradient901)'
                "
                height="66.145836"
                rx="14.567832"
                ry="14.567832"
                class="share-business__message-background"
                width="66.145836"
                x="-59.483067"
                y="145.8456" />
              <path
                id="path922"
                d="m -26.410149,157.29606 a 24.278298,20.222157 0 0 0 -24.278105,20.22202 24.278298,20.222157 0 0 0 11.79463,17.31574 27.365264,20.222157 0 0 1 -4.245218,5.94228 23.85735,20.222157 0 0 0 9.86038,-3.87367 24.278298,20.222157 0 0 0 6.868313,0.83768 24.278298,20.222157 0 0 0 24.2781059,-20.22203 24.278298,20.222157 0 0 0 -24.2781059,-20.22202 z"
                inkscape:connector-curvature="0"
                class="share-business__message-bubble" />
            </g>
          </g>
        </svg>
        <div class="share-business__social-label">Messages</div>
      </div>
      <div
        (click)="sendEmail()"
        class="messenger share-business__social-item share-business__email-item">
        <div
          [ngClass]="{ gradient: is3WaySharing }"
          class="share-business__email-icon">
          <fa-icon
            [icon]="faEnvelope"
            class="share-business__email-glyph"
            size="2x"></fa-icon>
        </div>
        <div class="share-business__social-label share-business__email-label">
          Email
        </div>
      </div>
      <div
        (click)="share('linkedin', shareUrl)"
        class="messenger share-business__social-item">
        <img
          alt="LinkedIn"
          class="sms-button share-business__social-image"
          src="assets/images/pitch-card-svg/linkedin-icon.svg" />
        <div class="share-business__social-label">LinkedIn</div>
      </div>
      <div
        (click)="share('facebook', shareUrl)"
        class="messenger share-business__social-item">
        <img
          alt="Facebook"
          class="sms-button share-business__social-image"
          src="assets/images/pitch-card-svg/facebook-icon.svg" />
        <div class="share-business__social-label">Facebook</div>
      </div>
      <div
        (click)="share('x', shareUrl)"
        class="messenger share-business__social-item">
        <img
          alt=""
          class="sms-button share-business__social-image"
          src="assets/images/pitch-card-svg/twitter-icon.svg" />
        <div class="share-business__social-label">X.com</div>
      </div>
      @if (!isEmbedded && !isMobile && !isPocketSharing) {
        <div
          (click)="embededDialog()"
          class="messenger inline-flex relative flex-column share-business__embed-item">
          <div class="share-business__embed-icon">
            <i class="pi pi-code share-business__embed-glyph"></i>
          </div>
          <div class="share-business__social-label">Embed Code</div>
        </div>
      }
    </div>
    <div class="p-inputgroup flex">
      <span class="mi-share-link">
        <button
          #copyButton
          (click)="copyLink()"
          class="copy-link-btn"
          pTooltip="Copy Link"
          tooltipPosition="bottom"
          type="button">
          Copy
        </button>
      </span>
      <input
        [value]="shareUrl"
        appNoLeadingSpace
        class="flex-auto border-none overflow-visible"
        pInputText
        type="text" />
    </div>
  </div>
</div>

<p-dialog
  (onHide)="onHideShareSmsDialog()"
  [(visible)]="shareSms"
  [blockScroll]="true"
  [dismissableMask]="false"
  [draggable]="false"
  [modal]="true"
  [baseZIndex]="11000"
  [appendTo]="'body'"
  maskStyleClass="sms-dialog-mask"
  [style]="{
    width: '720px',
    maxWidth: '100%'
  }"
  styleClass=" thank-you-dialog sms-dialog custom-width-dialog mi-mob-fullscreen-dialog">
  <form [formGroup]="contactForm" action="">
    <div class="title" translate>lbl_enter_contact_number</div>
    <div *ngIf="isBrowser" class="form-control">
      <app-country-input
        [label]="'label_mobile_number' | translate"
        formControlName="contactNumber"
        [inputStyleClass]="'input-primary sm mt-0'"
        [flagDropdownStyle]="'business-information-field'"
        [labelClass]="'business-information-field-label'"></app-country-input>
      <div
        *ngIf="submittedSms && form.contactNumber.errors"
        class="form-errors">
        <div *ngIf="contactForm.get('contactNumber').errors.required" translate>
          required_contact_number
        </div>
        <div *ngIf="contactForm.get('contactNumber').errors.pattern" translate>
          err_invalid_contact
        </div>
      </div>
    </div>
    <div>
      <br />
    </div>
    <div class="md:col-3 col-6 margin-centered">
      <button
        (click)="sendSMSToReferral()"
        [disabled]="
          !this.contactForm.get('contactNumber').value ||
          !this.contactForm.get('contactNumber').valid
        "
        class="button-simple shock-pink sm-35 uppercase full-width"
        translate="">
        label_send
      </button>
    </div>
  </form>
</p-dialog>
<app-embedded-code-dialog [(visible)]="embeddedDialogShow" [alias]="cardAlias">
</app-embedded-code-dialog>
<p-dialog
  [(visible)]="isQrShowed"
  [blockScroll]="true"
  [dismissableMask]="true"
  [modal]="true"
  [showHeader]="false"
  [baseZIndex]="11000"
  appendTo="body"
  maskStyleClass="qr-dialog-mask"
  class="dialog-no-padding"
  closable="true">
  <app-angularx-qrcode
    *ngIf="shareUrl"
    [level]="'M'"
    [qrdata]="shareUrl"
    [size]="250">
  </app-angularx-qrcode>
</p-dialog>
